import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-hot-toast';
import VaultoLogo from './VaultoLogo';

const AffiliateRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // eslint-disable-next-line no-unused-vars
  const [validating, setValidating] = useState(true);

  useEffect(() => {
    const handleAffiliate = async () => {
      if (!code) {
        navigate('/');
        return;
      }

      try {
        // Get tracking parameters from URL
        const utmSource = searchParams.get('utm_source');
        const utmMedium = searchParams.get('utm_medium');
        const utmCampaign = searchParams.get('utm_campaign');
        const sub1 = searchParams.get('sub1');
        const sub2 = searchParams.get('sub2');
        const sub3 = searchParams.get('sub3');
        const page = searchParams.get('page') || 'home';
        
        // Capture the original referrer (where user came from before clicking affiliate link)
        const originalReferrer = document.referrer;

        // Track the affiliate visit with all parameters
        try {
          const trackParams = {};
          if (utmSource) trackParams.utm_source = utmSource;
          if (utmMedium) trackParams.utm_medium = utmMedium;
          if (utmCampaign) trackParams.utm_campaign = utmCampaign;
          if (sub1) trackParams.sub1 = sub1;
          if (sub2) trackParams.sub2 = sub2;
          if (sub3) trackParams.sub3 = sub3;
          if (page) trackParams.page = page;
          if (originalReferrer) trackParams.original_referrer = originalReferrer;
          
          await api.post(`/aff/${code}/visit`, null, { params: trackParams });
        } catch (visitError) {
          // Don't block redirect if visit tracking fails
          console.warn('Failed to track affiliate visit:', visitError);
        }

        // Validate the affiliate code
        const response = await api.get(`/aff/${code}/validate`);

        // Determine landing page based on 'page' parameter
        const pageRoutes = {
          'home': '/',
          'register': '/register',
          'login': '/login',
          'pricing': '/pricing'
        };
        const targetPage = pageRoutes[page] || '/';

        if (response.data?.valid) {
          // Build redirect URL with affiliate code and tracking params
          const params = new URLSearchParams();
          params.set('aff', code);
          if (utmSource) params.set('utm_source', utmSource);
          if (utmMedium) params.set('utm_medium', utmMedium);
          if (utmCampaign) params.set('utm_campaign', utmCampaign);
          if (sub1) params.set('sub1', sub1);
          if (sub2) params.set('sub2', sub2);
          if (sub3) params.set('sub3', sub3);

          // Redirect to target page with affiliate code
          navigate(`${targetPage}?${params.toString()}`);
        } else {
          toast.error('Invalid affiliate code');
          navigate('/');
        }
      } catch (error) {
        console.error('Error handling affiliate:', error);
        // Still redirect even if validation fails
        const params = new URLSearchParams();
        params.set('aff', code);
        
        // Preserve tracking params
        const page = searchParams.get('page') || 'home';
        const pageRoutes = { 'home': '/', 'register': '/register', 'login': '/login', 'pricing': '/pricing' };
        const targetPage = pageRoutes[page] || '/';
        
        const utmSource = searchParams.get('utm_source');
        const utmMedium = searchParams.get('utm_medium');
        const utmCampaign = searchParams.get('utm_campaign');
        const sub1 = searchParams.get('sub1');
        const sub2 = searchParams.get('sub2');
        const sub3 = searchParams.get('sub3');
        if (utmSource) params.set('utm_source', utmSource);
        if (utmMedium) params.set('utm_medium', utmMedium);
        if (utmCampaign) params.set('utm_campaign', utmCampaign);
        if (sub1) params.set('sub1', sub1);
        if (sub2) params.set('sub2', sub2);
        if (sub3) params.set('sub3', sub3);

        navigate(`${targetPage}?${params.toString()}`);
      }
    };

    handleAffiliate();
  }, [code, navigate, searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-800 flex items-center justify-center">
      <div className="text-center">
        <VaultoLogo className="h-16 w-auto mx-auto mb-4" showText={true} />
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto"></div>
        <p className="mt-4 text-white">Redirecting...</p>
      </div>
    </div>
  );
};

export default AffiliateRedirect;

